// start:ng42.barrel
export * from './breed.facade';
export * from './breed.model';
// end:ng42.barrel

